import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { Container, Box as BaseBox } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

const printable = (props) => !props.printable && { '@media print': { display: 'none' } };
const Box = styled(BaseBox)(printable);

const NarrowContainer = styled(Container)`
  ${mediaQuery.minWidth.md} {
    max-width: ${rem('812px')};
  }
`;

const PageBlock = React.forwardRef(({ children, narrow, gutter, printable, ...rest }, ref) => {
  const Wrapper = narrow ? NarrowContainer : Container;

  return (
    <Box ref={ref} printable={printable} {...rest}>
      <Wrapper gutter={gutter}>{children}</Wrapper>
    </Box>
  );
});

PageBlock.displayName = 'PageBlock';

PageBlock.propTypes = {
  children: PropTypes.node,
  narrow: PropTypes.bool,
  printable: PropTypes.bool,
  gutter: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
};

PageBlock.defaultProps = {
  children: null,
  narrow: false,
  printable: true,
  gutter: Container.defaultProps.gutter,
};

export default PageBlock;
